import React from "react";

const TeacherCard = (props) => {
  return (
    <div className="flex flex-col w-1/3 bg-white rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#ef4444]  items-center transform transition-transform duration-300 hover:-translate-y-2">
      <div className="h-[150px] w-[150px]  bg-red-200 rounded-full overflow-hidden mt-4">
        <img src={props.src} alt="Patricia Lilian" className="scale-110" />
      </div>
      <div className="h-3/5 p-4 flex flex-col gap-1 text-center">
        <p className="text-2xl font-bold text-primario ">{props.nombre}</p>
        <p className="text-lg font-bold text-red-500">{props.habilidad}</p>
        <p className="text-sm hyphens-none">
          {props.bio}
        </p>
      </div>
    </div>
  );
};

export default TeacherCard;
